<template>
  <b-modal
    id="import-case-info"
    :title="$translate('This cases was not imported:')"
    hide-footer
    centered
    content-class="rounded-8"
  >
    <div class="row">
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12">
        <Table
          :columns="columns"
          :rows="nonImportedCaseList"
          class="overflow-auto pr-1"
          table-name="nonImportedCaseList"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12 d-flex justify-content-center mt-3">
        <b-button
          variant="outline-primary"
          size="lg"
          class="px-75"
          @click="onClose"
        >
          {{ 'Ok' | i18n }}
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Table from '../../common/table';

export default {
  name: 'ImportCaseInfo',
  components: { Table },
  props: {
    nonImportedCaseList: {
      type: Array,
      default: () => [],
    },
  },
  data: function () {
    return {
      columns: [
        { field: 'rowNumber', key: 'rowNumber', title: this.$translate('Row number') },
        { field: 'emptyFields', key: 'emptyFields', title: this.$translate('No required fields') },
      ],
    };
  },
  methods: {
    onClose() {
      this.$root.$emit('bv::hide::modal', 'import-case-info');
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .modal-header {
  border: none;
  padding-bottom: 0px !important;
}
.px-75 {
  padding-left: 75px;
  padding-right: 75px;
}
.text-message {
  font-size: 16px;
}
.color-blue {
  color: #2260ff;
}
::v-deep .rounded-8 {
  border-radius: 8px;
}
::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
</style>
